import React, { Component } from "react";
import { GridRow } from "arv-reactcomponents";
import StoreLocatorLink from "./StoreLocatorLink";
import EmailSubscription from "./EmailSubscription";
import SocialLinks from "./SocialLinks";

class MainBar extends Component {
  componentDidMount() {
    console.log(this);
  }
  render() {
    return (
      <GridRow className="wc-footermainbar">
        <StoreLocatorLink className="nw-desktop-only nwc-grid-col-sm-4" />
        <EmailSubscription />
        <StoreLocatorLink className="nw-mobile-only nwc-grid-col-xs-6" />
        <SocialLinks />
      </GridRow>
    );
  }
}

export default MainBar;
